export default __webpack_public_path__ + "static/media/food3.4934d6a9.png";